import React, { useEffect, useState } from 'react';
import { Editor } from '@meitu/saas-editor-core';
import { BackgroundLayer } from '@meitu/saas-editor-core/es/layers/background-layer';
import { ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import DynamicBgLayerContent from './dynamic-bg-layer-content';

const DynamicBgLayer: React.FC<{ editor: Editor; isAiPPT: boolean }> = ({ editor, isAiPPT }) => {
    const { width, height } = editor.stage.getActiveSize();
    const [backgroundLayer, setBackgroundLayer] = useState<ILayerProps | null>(
        editor.getInstance(BackgroundLayer).getBackgroundLayer(),
    );

    useEffect(() => {
        if (!backgroundLayer?.id) return;
        const handler = editor.stage.onLayerChange(() => {
            setBackgroundLayer(editor.getInstance(BackgroundLayer).getBackgroundLayer());
        }, backgroundLayer?.id);
        return () => {
            editor.off(handler);
        };
    }, [backgroundLayer?.id]);

    if (!isAiPPT) {
        return null;
    }

    return <DynamicBgLayerContent width={width} height={height} backgroundLayer={backgroundLayer} />;
};

export default DynamicBgLayer;
